import type { ReactElement } from 'react';
import { CLIENT_COPY, type ConsentCopy } from '../../../../../shared/client-copy.js';

/** The age box's line, every door's (src/shared/client-copy.js, 2026-10-21 Riley). */
export const CONSENT_AGE = CLIENT_COPY.legal.consent.age;

/**
 * What stands over the two boxes wherever the web asks them before a talk (2026-10-23 jam): one heading and one
 * line, the same at every door — the talk page's sheet, the games' handoff, the home composer's sheet (the line only).
 * The apps ask no boxes (sign-in only), so this is the web's.
 */
export const CONSENT_TITLE = 'Before we talk';
export const CONSENT_NOTE = 'Ember is an AI. Two quick things first.';

/**
 * A door's Terms sentence with its two links, from the one source all three
 * clients read (src/shared/client-copy.js legal.consent, served to the apps
 * over /api/app/config — 2026-10-21 Riley). Each door keeps its own anchor
 * attributes: rel, and the data-log names where it has them.
 */
export function ConsentTerms({ door, rel = 'noreferrer', termsLog, privacyLog }: {
  door: Exclude<keyof ConsentCopy, 'age'>;
  rel?: string;
  termsLog?: string;
  privacyLog?: string;
}): ReactElement {
  const s = CLIENT_COPY.legal.consent[door];
  return (
    <span>
      {s.before}
      <a href={s.terms_href} target="_blank" rel={rel} data-log={termsLog}>{s.terms_label}</a>
      {s.between}
      <a href={s.privacy_href} target="_blank" rel={rel} data-log={privacyLog}>{s.privacy_label}</a>
      {s.after}
    </span>
  );
}
